import React from "react";
import "../Styling/Navi1StaCard.css";

function Navi1StaCard({ title, value, color, alert }) {
  return (
    <div
      className="Navi1StaCard"
      style={{
        backgroundColor: `${color}0D`, // 5% opacity
      }}
    >
      {/* Top Right Triangle */}
      <div
        className="corner-top"
        style={{ borderTopColor: color }}
      ></div>

      {/* Bottom Left Triangle */}
      <div
        className="corner-bottom"
        style={{ borderBottomColor: color }}
      ></div>

      <h4 className="heading">{title}</h4>

      <div className="card-value">
        {value}
        {alert && <span className="alert-icon"> »</span>}
      </div>
    </div>
  );
}

export default Navi1StaCard;